export default __webpack_public_path__ + "assets/img/icon_id_docu_small.png";